import { useQuery } from "react-query";
import { paywallCheckoutApi } from "@/react/api/paywallCheckoutApi";
import type { CheckoutProps } from "@/react/components/Paywalls/Checkout/types/CheckoutProps";
import type { ShowEndpointQueryParams } from "@/react/helpers/urlHelpers/internalApi/paywalls/checkout";
import type { CurrentCommunityMember } from "@/react/types/CurrentCommunityMember";

const key = "paywall-checkout-preview";

interface PaywallCheckoutShowCommunityMember extends CurrentCommunityMember {
  billing_info: CheckoutProps["memberBillingInfo"];
}

interface PaywallCheckoutShowEndpointResponse {
  auth_provider: {
    name: string;
    is_sso_authentication_required: boolean;
  };
  community: CheckoutProps["currentCommunity"];
  community_member: PaywallCheckoutShowCommunityMember;
  community_member_payment_processor: {
    is_member_with_saved_payment_methods: boolean;
    session_client_secret?: string;
  };
  community_payment_processor: {
    payment_method_configuration_id: CheckoutProps["currentCommunityProcessorPaymentMethodConfigurationId"];
    processor_id: string;
    public_api_key: string;
    is_link_capability_active: boolean;
    is_brazilian_account_and_processor_stripe_brazil: boolean;
    is_tax_id_mandatory: boolean;
  };
  policies: {
    are_coupons_enabled: boolean;
    has_already_purchased: boolean;
    is_member_address_required: boolean;
    should_show_tax_id_form: boolean;
  };
  settings: {
    login_url: string;
    reset_password_url: string;
    community_url: string;
    checkout_confirmation_url: string;
  };
  user: CheckoutProps["currentUser"];
}

export const useFetchCheckoutData = (
  params: ShowEndpointQueryParams,
  enabled: boolean = true,
) => {
  const showQuery = useQuery<PaywallCheckoutShowEndpointResponse>({
    queryKey: [key, params],
    queryFn: () => paywallCheckoutApi.show(params),
    enabled,
  });

  return {
    showQuery,
  };
};
